import { Dispatch } from "redux";
import {QuickbetsActionTypes, QuickbetsAction} from "../../types/Quickbet/quickbetsTypes";
import axios from "axios";

interface ErrorResponse {
    code: number;
    message: string;
}

export const getQuickbetsData = (): any => {
    return async (dispatch: Dispatch<QuickbetsAction>) => {
        try {
            dispatch({ type: QuickbetsActionTypes.FETCH_QUICKBETS_DATA });
            const response = await axios({
                method: 'get',
                url: `/api/quickbet_cards`,
                withCredentials: false
            });
            dispatch({ type: QuickbetsActionTypes.FETCH_QUICKBETS_DATA_SUCCESS, payload: response.data });
        } catch (error: any) {
            let errorPayload: ErrorResponse;
            if (error.response && error.response.data) {
                const { code, message } = error.response.data;
                errorPayload = { code, message };
            } else {
                errorPayload = { code: -1, message: 'Unknown error occurred' };
            }
            dispatch({ type: QuickbetsActionTypes.FETCH_QUICKBETS_DATA_ERROR, payload: errorPayload });
        }
    }
}
